import { Component, Mixins, Prop } from 'vue-property-decorator';
import addCollaborativeFilteringSuggestionMutation from '../../mutations/addCollaborativeFilteringSuggestion';
import collaborativeFilteringSuggestionsQuery from '../../queries/collaborativeFilteringSuggestions';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListCollaborativeFilteringAdder extends Mixins(
  UtilMixin
) {
  @Prop() public suggestionsList!: any;

  public readonly query = collaborativeFilteringSuggestionsQuery;
  public readonly mutation = addCollaborativeFilteringSuggestionMutation;

  public mutationVariables(suggestionCandidate: any) {
    return {
      suggestionsListId: this.suggestionsList.id,
      publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
      position: suggestionCandidate.source.position,
      among: suggestionCandidate.source.among,
    };
  }
}
